/* eslint-disable */
import { defineStore } from 'pinia';
import { useInitializeStore } from './initialize';
import { initLiveChat, openLiveChat as openLiveChatPlugin } from '@/plugins/live_chat';

export const usePlatformConfigurationStore = defineStore('platform_configuration', {
	state: () => ({
		platform_configuration: [],
		live_chat: {
			enabled: false,
			provider: 'none',
			hide_bubble: false,
			crisp_website_id: '',
			tawk_to_url: '',
			zendesk_key: '',
			hoory_website_token: '',
			hoory_base_url: '',
			liveagent_button_id: '',
			liveagent_url: '',
		},
	}),
	getters: {
		getPlatformConfiguration(state) {
			return state.platform_configuration
		},
		isRememberMeEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'login_remember_me');
			if (!config) return false; // Explicit default

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 0;
		},
		isResponsibleBettingModalEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'responsible_betting_modal');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showNotificationIconOnMobileHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_notifications_icon_on_mobile_header');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isEmailVerificationEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'email_verification');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isCustomerVerificationEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'customer_verification');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isVerificationTabEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'verification_process_tab');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isGhanaSmsVerificationEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'sms_verification');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isShowNationalIdEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_national_id_number');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isShowCallBubbleEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_call_bubble');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isShowPendingDepositsEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_pending_deposits');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isCompactHeroBannersEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_compact_hero_banners_without_overlays');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isGradientColorOnPromotionsEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_gradient_color_on_promotions');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isTransparentHeaderEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_transparent_homepage_header');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isPasswordUnSafe(state) {
			const config = state.platform_configuration.find(configuration => configuration.name === 'unsafe_password');
			if (!config) return true;

			if (config.value == 'false') return false;
			return true;
		},
		isGradientColorOnLoginRegisterEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_gradient_color_on_login_and_register_page');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showTextInsidePromotions: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_text_inside_promotions');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isMultiThemeSupportEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_theme_support');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isNewPreSportsLayoutEnabled: (state) => {
			const initializeStore = useInitializeStore();
			if (initializeStore.screenWidth > 991) return false;

			const config = state.platform_configuration.find(configuration => configuration.name === 'use_new_pre_sports_mobile_layout');
			if (!config) return false; // Explicit default

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 0;
		},
		isLiveChatHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'live_chat_header');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isBetslipLayerEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_betslip_additional_layer');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;

		},
		isReferralEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_referral_system');
			if (!config) return false;


			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isAcceptAnyOddsEnabledOnBetslip: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'accept_any_odds_on_betslip');
			if (!config) return true;


			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isBetInfluencerEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_bet_influencer_system');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';
		},
		isPromotionCodeEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_promotion_code_system');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isLaternaEnabled(state) {
			const initializeStore = useInitializeStore();
			// if (initializeStore.screenWidth > 991) return false;
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_new_landing_page_layout');
			if (!config) return false;

			if (config.value == 'false') return false;
			return true;
		},
		hasSmallMobileCasinoBanners(state) {
			const initializeStore = useInitializeStore();
			if (initializeStore.screenWidth > 991) return false;

			const config = state.platform_configuration.find(configuration => configuration.name === 'use_small_mobile_casino_banners');
			if (!config) return false;

			if (config.value == 'false') return false;
			return true;
		},
		hasLargeLandingMenu(state) {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_large_landing_menu');
			if (!config) return false;

			if (config.value == 'false') return false;
			return true;
		},
		hasVamosBanners(state) {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_vamos_banners');
			if (!config) return false;

			if (config.value == 'false') return false;
			return true;
		},
		showExtendedBonusInfo: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_extended_bonus_info');
			if (!config) return true;
			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';
			return value === 1;
		},
		isAthenaPixelEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'enable_athena_pixel');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isLaternaBannersEnabled(state) {
			const config = state.platform_configuration.find(configuration => configuration.name === 'use_laterna_banners');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showWhatsappOnHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_whatsapp_on_header');
			if (!config) return false;

			const value = config.value;
			if (!value) return false;

			return value
		},
		showVerificationWarning: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_verification_warning');

			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showWalletButtonInsteadOfDepositInHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_wallet_button_instead_of_deposit_in_header');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showNotificationIconOnMobileHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_notifications_icon_on_mobile_header');
			if (!config) return true;
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';
			return value === 1;
		},
		showGoToCasinoAfterDepositButton: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_go_to_casino_after_deposit_button');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';
			return value === 1;
		},
		showThemeSwitchIconOnMobileHeader: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_theme_switch_icon_on_mobile_header');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isLiveChatEnabled: (state) => {
			const value = state.live_chat?.enabled;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		hideLiveChatBubble: (state) => {
			const value = state.live_chat?.hide_bubble;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		liveChatProvider: (state) => state.live_chat?.provider || 'none',
		crispWebsiteId: (state) => state.live_chat?.crisp_website_id || '',
		tawkToUrl: (state) => state.live_chat?.tawk_to_url || '',
		zendeskKey: (state) => state.live_chat?.zendesk_key || '',
		hooryWebsiteToken: (state) => state.live_chat?.hoory_website_token || '',
		hooryBaseUrl: (state) => state.live_chat?.hoory_base_url || 'https://app.hoory.com',
		liveagentButtonId: (state) => state.live_chat?.liveagent_button_id || '',
		liveagentUrl: (state) => state.live_chat?.liveagent_url || 'https://betegram.ladesk.com/scripts/track.js',
		isNewPreSportsDesignEnabled: (state) => {
			return true;
			const config = state.platform_configuration.find(configuration => configuration.name === 'new_pre_sports_design_enabled');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		sortUpcomingDays: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'sort_upcoming_days');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		showOnlyFixturesOnHighlights: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_only_fixtures_on_highlights');
			if (!config) return false;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		getLoginNumber: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'login_number_placeholder');
			if (!config) return '577123123';

			return config.value;
		},
		isBetBoostHighlightWidgetEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_bet_boosts_widget_on_highlights');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isBetBoostCompetitionWidgetEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_bet_boosts_widget_on_competitions');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isBetBoostFixtureWidgetEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_bet_boosts_widget_inside_fixture');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},
		isBetBoostMobileQuickPicksEnabled: (state) => {
			const config = state.platform_configuration.find(configuration => configuration.name === 'show_bet_boosts_widget_on_mobile_quick_picks');
			if (!config) return true;

			const value = config.value;
			if (typeof value === 'boolean') return value;
			if (typeof value === 'string') return value === 'true' || value === '1';

			return value === 1;
		},

	},
	actions: {
		setPlatformConfiguration(data) {
			this.platform_configuration = data;
		},
		setLiveChat(data) {
			if (data) {
				this.live_chat = data;
				initLiveChat({
					chatEnabled: this.isLiveChatEnabled,
					provider: this.liveChatProvider,
					hideBubble: this.hideLiveChatBubble,
					crispWebsiteId: this.crispWebsiteId,
					talkToSrc: this.tawkToUrl,
					zendeskKey: this.zendeskKey,
					hooryWebsiteToken: this.hooryWebsiteToken,
					hooryBaseUrl: this.hooryBaseUrl,
					liveagentButtonId: this.liveagentButtonId,
					liveagentUrl: this.liveagentUrl,
				});
			}
		},
		openLiveChat() {
			openLiveChatPlugin(this.hideLiveChatBubble);
		},
	},
});